<form [formGroup]="form" (submit)="submit()" class="user-layout-form">
  <app-error></app-error>
  <input placeholder="uporabnik" type="email" formControlName="email">
  <input placeholder="geslo" type="password" formControlName="password">
  <button type="submit" [disabled]="form.invalid">
    <i class="icon-accept_small"></i>
  </button>
  <div class="links">
    <a href="mailto:solskilonec@nijz.si">Kontakt</a>
    <a [routerLink]="['/lost-password']">Pozabljeno geslo</a>
  </div>
</form>
